import axios from 'axios';
import { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import DashboardLayout from './DashboardLayout ';
import './HrDashboard.css';
import LocationPicker from './LocationPicker';
// import ReactTagInput from '@pathofdev/react-tag-input';
// import "@pathofdev/react-tag-input/build/index.css";
import CreatableSelect from 'react-select/creatable';
import JobTypeOptions from './JobTypeOptions';


const AddJob = () => {
  const BASE_API_URL = process.env.REACT_APP_API_URL;
  const userFromLocalStorage = JSON.parse(localStorage.getItem('user'));
  const companyName = userFromLocalStorage?.companyName;
  const location = useLocation();
  const navigate = useNavigate();
  const { userName, userEmail, job } = location.state || {};
  const [suggestedSkills, setSuggestedSkills] = useState([]);
  const [showSuggestedSkills, setShowSuggestedSkills] = useState(true); // <-- toggle state


  const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
  const [countryCode, setCountryCode] = useState('IN');
  const lsKey = `locs_${companyName}_${countryCode}`;
  const [locations, setLocations] = useLocalStorage(lsKey, []);




  const getNextYearDate = () => {
    const today = new Date();
    const nextYear = new Date(today);
    nextYear.setFullYear(today.getFullYear() + 1);
    return nextYear.toISOString().split('T')[0];
  };

  const [formData, setFormData] = useState({
    userEmail: userEmail || '',
    jobTitle: '',
    jobType: 'Full Time',
    location: 'India',
    salary: '30000',
    postingDate: today,
    qualifications: '',
    applicationDeadline: getNextYearDate(),
    numberOfPosition: '',
    jobsummary: '',
    minExp: 0,
    maxExp: 99,
    skills: [],  // <-- changed to array--> npm install react-select --legacy-peer-deps
    jobCategory: 'temp',
  });



  const [selectedLocs, setSelectedLocs] = useState([]);


  const jobTypeOptions = [
    "Full Time",
    "Part Time",
    "Contract",
    "Internship",
    "Temporary",
    "Freelance",
    "Work From Home",
    "Remote",
    "On-site",
    "Hybrid"
  ];


  // Set hrEmail initially if userEmail is present
  useEffect(() => {
    if (userEmail) {
      setFormData(prev => ({
        ...prev,
        userEmail: userEmail,
      }));
    }
  }, [userEmail]);

  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      location: selectedLocs.join(', ')
    }));
  }, [selectedLocs]);

  // Prefill form data from job if present
  useEffect(() => {
    if (job) {
      setFormData(prev => ({
        ...prev,
        userEmail: userEmail,
        jobTitle: job.jobTitle || '',
        location: job.location || prev.location,
        salary: job.salary || prev.salary,
        jobsummary: job.description || '',
        jobType: job.jobType || prev.jobType,
        // minExp and maxExp remain default unless you add job.minExp / job.maxExp
      }));
    }
  }, [job, userEmail]);

  useEffect(() => {
    if (!companyName) return;

    axios
      .get(`${BASE_API_URL}/getLocationsForCompany`, {
        params: { companyName, countryCode: countryCode.toLowerCase() }
      })
      .then(res => {
        setLocations(res.data || []);
        // Reset the selected location when country changes
        setFormData(prev => ({
          ...prev,
          location: (res.data && res.data[0]) || ''
        }));
      })
      .catch(console.error);
  }, [companyName, countryCode]);


  function useLocalStorage(key, initialValue) {
    const [value, setValue] = useState(() => {
      const saved = localStorage.getItem(key);
      return saved ? JSON.parse(saved) : initialValue;
    });

    useEffect(() => {
      localStorage.setItem(key, JSON.stringify(value));
    }, [key, value]);

    return [value, setValue];
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    const updatedFormData = {
      ...formData,
      skills: formData.skills.join(', '), // Convert array to comma-separated string
      location: selectedLocs.join(', '),
      countryCode: formData.countryCode || countryCode,
    };
    try {
      const response = await saveJobData(updatedFormData);
      if (response.ok) {
        await Swal.fire({
          icon: "success",
          title: "Job post Successful!",
          text: "You have successfully posted this job.",
        });
        navigate('/hr-dashboard/my-jobs/addJob/jodAddSuccess', {
          state: { userName, userEmail },
        });
      } else {
        throw new Error('Job submission failed');
      }
    } catch (error) {
      // You may want to handle the error here, e.g. show an alert
      console.error(error);
    }
  };

  const saveJobData = async (formData) => {
    console.log(formData)
    try {
      const response = await fetch(`${BASE_API_URL}/postingJob`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      return response;
    } catch (error) {
      throw new Error("Invalid Job details");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleJobTitleBlur = async () => {
    const jobTitle = formData.jobTitle;
    if (jobTitle && jobTitle.length > 3) {
      const suggested = await fetchSkillsForJobTitle(jobTitle);
      setSuggestedSkills(suggested);
    }
  };

  const fetchSkillsForJobTitle = async (jobTitle) => {
    try {
      const response = await axios.get(`${BASE_API_URL}/skills`, {
        params: { jobTitle }
      });
      return response.data; // Array of skills
    } catch (error) {
      console.error('Error fetching skills:', error);
      return [];
    }
  };

  const handleBack = () => {
    navigate(-1);
  };


  const handleLocationChange = (locs, country) => {
    setSelectedLocs(locs);
    setFormData(f => ({
      ...f,
      countryCode: country,
      location: locs.join(', '),
    }));
  };
  return (
    <DashboardLayout>
      <div className="main-content">
        <Card style={{ marginTop: '5px', width: '98%', marginLeft: '10px' }}>
          <Card.Header>
            <Card.Title className="mb-0" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <h3 style={{ fontSize: '25px', margin: 0 }}>Post Job</h3>
              <p style={{ margin: 0 }}>(Add a new job posting to attract top talent)</p>
            </Card.Title>
          </Card.Header>
          <Form onSubmit={handleSubmit}>
            <Card.Body>
              <Row style={{ marginBottom: '24px' }}>
                <Col md={6}>
                  <Form.Group controlId="jobTitle">
                    <Form.Label className="required-label">Job Title:</Form.Label>
                    <Form.Control
                      type="text"
                      name="jobTitle"
                      value={formData.jobTitle}
                      onChange={handleChange}
                      onBlur={handleJobTitleBlur}
                      placeholder="Eg: Java Developer, Full Stack Developer"
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="jobType">
                    <Form.Label className="required-label">Job Type:</Form.Label>
                    <Form.Select
                      className="form-jobType"
                      name="jobType"
                      value={formData.jobType}
                      onChange={handleChange}
                      required
                    >
                      {JobTypeOptions.map((type, index) => (
                        <option key={index} value={type}>{type}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

              </Row>

              <Row style={{ marginBottom: '24px' }}>
                <Col md={6}>
                  <Form.Group controlId="postingDate">
                    <Form.Label className="required-label">Posting Date:</Form.Label>
                    <Form.Control
                      type="date"
                      name="postingDate"
                      value={formData.postingDate}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="skills">
                    <Form.Label className="required-label">Skills:</Form.Label>
                    <CreatableSelect
                      isMulti
                      value={formData.skills.map(skill => ({ label: skill, value: skill }))}
                      onChange={(selectedOptions) =>
                        setFormData({ ...formData, skills: selectedOptions.map(opt => opt.value) })
                      }
                      placeholder="Eg: Java, Python, React"
                    />
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '8px' }}>
                      <Form.Text className="text-muted">
                        * Suggested skills based on job title. Click to add:
                      </Form.Text>
                      <Button
                        variant="link"
                        size="sm"
                        style={{ padding: 0, fontSize: '0.9rem' }}
                        onClick={() => setShowSuggestedSkills(prev => !prev)}
                      >
                        {showSuggestedSkills ? 'Hide' : 'Show'}
                      </Button>
                    </div>

                    {showSuggestedSkills && (
                      <div style={{ marginTop: '5px' }}>
                        {suggestedSkills.map((skill, idx) => (
                          <Button
                            key={idx}
                            variant="outline-secondary"
                            size="sm"
                            style={{ margin: '4px' }}
                            onClick={() => {
                              if (!formData.skills.includes(skill)) {
                                setFormData((prev) => ({
                                  ...prev,
                                  skills: [...prev.skills, skill],
                                }));
                              }
                            }}
                          >
                            {skill}
                          </Button>
                        ))}
                      </div>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              <Row style={{ marginBottom: '24px' }}>
                <Col md={6}>
                  <Form.Group controlId="numberOfPosition">
                    <Form.Label className="required-label">Number of Positions:</Form.Label>
                    <Form.Control
                      type="number"
                      name="numberOfPosition"
                      value={formData.numberOfPosition}
                      onChange={handleChange}
                      placeholder="Number of openings"
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="salary">
                    <Form.Label className="required-label">Salary:</Form.Label>
                    <Form.Control
                      type="text"
                      name="salary"
                      value={formData.salary}
                      onChange={handleChange}
                      placeholder="Enter Salary"
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row style={{ marginBottom: '24px' }}>
                <Col md={6}>
                  <Form.Group controlId="applicationDeadline">
                    <Form.Label className="required-label">Application Deadline:</Form.Label>
                    <Form.Control
                      type="date"
                      name="applicationDeadline"
                      value={formData.applicationDeadline}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                  <p>(You can change Application deadline)</p>
                </Col>
                <Col md={6}>
                  <LocationPicker
                    companyName={companyName}
                    apiUrl={BASE_API_URL}
                    initialCountry="IN"
                    initialSelection={selectedLocs}
                    onChange={handleLocationChange}
                  />
                </Col>



              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group controlId="minExp">
                    <Form.Label className="required-label">Minimum Experience (Years):</Form.Label>
                    <Form.Control
                      type="number"
                      name="minExp"
                      value={formData.minExp}
                      onChange={handleChange}
                      min={0}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="maxExp">
                    <Form.Label className="required-label">Maximum Experience (Years):</Form.Label>
                    <Form.Control
                      type="number"
                      name="maxExp"
                      value={formData.maxExp}
                      onChange={handleChange}
                      min={formData.minExp || 0}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group controlId="jobsummary">
                <Form.Label className="required-label">Job summary: (Add Additional Information)</Form.Label>
                <Form.Control
                  as="textarea"
                  name="jobsummary"
                  value={formData.jobsummary}
                  onChange={handleChange}
                  className="fullWidthTextarea"
                  style={{ minHeight: '150px' }}
                />
              </Form.Group>
            </Card.Body>

            <Card.Footer>
              <div className="d-flex justify-content-center">
                <Button type="submit" className="btn btn-primary m-1">Post Job</Button>
                <Button className="btn btn-light m-1" onClick={handleBack}>Back</Button>
              </div>
            </Card.Footer>
          </Form>
        </Card>
      </div>
    </DashboardLayout >
  );
};

export default AddJob;
